

// import React, { useState, useEffect } from "react";

// function Customaicards() {
//   const features = [
//     {
//       title: "Advanced Machine Learning Models",
//       description:
//         "Leverage powerful machine learning algorithms to optimize business operations, improve customer experiences, and make data-driven decisions..",
//     },
//     {
//       title: "Natural Language Processing (NLP)",
//       description:
//         "Transform unstructured data, such as text and speech, into actionable insights, enabling better customer interactions, automated workflows, and smarter decision-making.",
//     },
//     {
//       title: "Data-Driven Insights",
//       description:
//         "Our AI solutions generate valuable insights from your data, helping you identify trends, optimize performance, and stay ahead of the competition.",
//     },
//     {
//       title: "Scalability and Flexibility",
//       description:
//         "We ensure that our AI solutions can scale as your business grows, adapting to changing needs and ensuring long-term value and success.",
//     },
//     {
//       title: "Seamless Integration",
//       description:
//         "Our AI models integrate smoothly with your existing systems, ensuring minimal disruption and maximum efficiency.",
//     },
//     {
//       title: "AI-Powered Automation",
//       description:
//         "Automate routine tasks, improve operational efficiency, and reduce manual errors with AI-powered automation solutions tailored to your business needs.",
//     },
//   ];

//   const [inView, setInView] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const topPosition = document.getElementById("features-section")?.getBoundingClientRect().top;
//       if (topPosition <= window.innerHeight * 0.75) {
//         setInView(true);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);

//     // Cleanup the event listener on unmount
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);

//   return (
//     <div
//       id="features-section"
//       style={{
//         ...styles.container,
//         backgroundImage: "url('/image/walp2.avif')", 
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <h2 style={styles.heading}>Key Features of Our Custom AI Solutions</h2>
//       <div
//         style={{
//           ...styles.cardsContainer,
//           transform: inView ? "translateY(0)" : "translateY(50px)",
//           opacity: inView ? 1 : 0,
//           transition: "all 1s ease",
//         }}
//       >
//         {features.map((feature, index) => (
//           <div
//             key={index}
//             style={{
//               ...styles.card,
//               transform: inView
//                 ? "translateX(0)"
//                 : index % 2 === 0
//                 ? "translateX(-100px)"
//                 : "translateX(100px)",
//               opacity: inView ? 1 : 0,
//               transition: `all 0.8s ease ${index * 0.1}s`,
//             }}
//           >
//             <h3 style={styles.cardTitle}>{feature.title}</h3>
//             <p style={styles.cardDescription}>{feature.description}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     padding: "5vw 5%",
//     textAlign: "center",
//     fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
//     minHeight: "100vh",
//     position: "relative",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//   },
//   heading: {
//     fontSize: "clamp(1.5rem, 5vw, 2.5rem)",
//     color: "black",
//     marginBottom: "clamp(20px, 5vw, 40px)",
//     fontWeight: "700",
//     position: "relative",
//     display: "inline-block",
//     padding: "0 20px",
//   },
//   cardsContainer: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fit, minmax(min(300px, 100%), 1fr))",
//     gap: "clamp(20px, 3vw, 30px)",
//     width: "90%",
//     maxWidth: "1200px",
//     margin: "0 auto",
//     padding: "20px",
//   },
//   card: {
//     backgroundColor: "#ffffff",
//     border: "none",
//     padding: "clamp(20px, 3vw, 30px)",
//     borderRadius: "12px",
//     boxShadow: "0 10px 20px rgba(0, 0, 0, 0.08)",
//     transition: "all 0.3s ease-in-out",
//     cursor: "pointer",
//     position: "relative",
//     overflow: "hidden",
//     zIndex: "1",
//     minHeight: "200px",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//     textAlign: "left",
//   },
//   cardTitle: {
//     fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
//     color: "#1e40af",
//     marginBottom: "15px",
//     fontWeight: "600",
//     position: "relative",
//     paddingBottom: "10px",
//   },
//   cardDescription: {
//     fontSize: "clamp(0.9rem, 2vw, 1rem)",
//     color: "#4b5563",
//     lineHeight: "1.6",
//     marginTop: "15px",
//   },
// };

// export default Customaicards;




import React from "react";
import { motion } from "framer-motion";

function Features() {
  const features = [
    {
      title: "Advanced Machine Learning Models",
      description:
        "Leverage powerful machine learning algorithms to optimize business operations, improve customer experiences, and make data-driven decisions.",
      color: "#1E40AF",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Natural Language Processing (NLP)",
      description:
        "Transform unstructured data, such as text and speech, into actionable insights, enabling better customer interactions, automated workflows, and smarter decision-making.",
      color: "#2563EB",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "Data-Driven Insights",
      description:
        "Our AI solutions generate valuable insights from your data, helping you identify trends, optimize performance, and stay ahead of the competition.",
      color: "#9333EA",
      animation: { x: 0, y: 100 }, // from bottom
    },
    {
      title: "Scalability and Flexibility",
      description:
        "We ensure that our AI solutions can scale as your business grows, adapting to changing needs and ensuring long-term value and success.",
      color: "#059669",
      animation: { x: -100, y: 0 }, // from left
    },
    {
      title: "Seamless Integration",
      description:
        "Our AI models integrate smoothly with your existing systems, ensuring minimal disruption and maximum efficiency.",
      color: "#DC2626",
      animation: { x: 100, y: 0 }, // from right
    },
    {
      title: "AI-Powered Automation",
      description:
        "Automate routine tasks, improve operational efficiency, and reduce manual errors with AI-powered automation solutions tailored to your business needs.",
      color: "#F59E0B",
      animation: { x: 0, y: -100 }, // from top
    },
  ];

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "linear-gradient(to right, #e0f2fe, #f8fafc)",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "40px",
      fontWeight: "bold",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)", // 3x3 layout like your screenshot
      gap: "25px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      padding: "25px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "180px",
      cursor: "pointer",
    },
    title: {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#374151",
    },
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Key Features of Our Custom AI Solutions</h2>
      <div style={styles.grid}>
        {features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ ...feature.animation, opacity: 0 }}
            whileInView={{ x: 0, y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
              e.currentTarget.style.transform = "translateY(-5px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default Features;
